module.exports = __webpack_public_path__ + "static/media/cloudCover.a6757c1d.svg";